import { apiRequest } from 'utils/request'

export const get = () =>
  apiRequest({
    uri: '/features/subGroups',
  })
